import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { FilterPicker, RadioButtonWithLabel } from 'seagull';
const RadioFilterPicker = (param)=>{
    let { title, testId, defaultLabel, selectedValue, defaultValue, removable, options, onApply, onRemove, startOpen } = param;
    const [label, setLabel] = useState(defaultLabel);
    const [currentValue, setCurrentValue] = useState(selectedValue);
    const appliedRef = useRef(false);
    useEffect(()=>{
        setCurrentValue(selectedValue);
    }, [
        selectedValue
    ]);
    return /*#__PURE__*/ _jsx(FilterPicker, {
        testId: testId,
        label: label,
        title: title || label,
        highlightTrigger: false,
        onApply: ()=>{
            appliedRef.current = true;
            if (defaultValue != null && currentValue === defaultValue) {
                setLabel(defaultLabel);
            } else {
                const selected = options.find((o)=>o.value === currentValue);
                if (selected) setLabel(selected.label);
            }
            onApply(currentValue);
        },
        onClose: ()=>{
            if (!appliedRef.current) {
                setCurrentValue(selectedValue);
            }
            appliedRef.current = false;
        },
        onRemove: onRemove,
        removable: removable,
        startOpen: startOpen,
        children: options.map((param)=>{
            let { value, label: optionLabel, sublabel } = param;
            return /*#__PURE__*/ _jsx(RadioButtonWithLabel, {
                bi: {
                    name: 'filter_option'
                },
                label: optionLabel,
                sublabel: sublabel,
                testId: "".concat(testId, "-option-").concat(value),
                checked: value === currentValue,
                onChange: ()=>{
                    setCurrentValue(value);
                }
            }, value);
        })
    });
};
export default RadioFilterPicker;
